import styled from "styled-components";

export const FooterWrapper = styled.footer`
  background-color: ${({ theme }) => theme.palette.neutral.dark};
  color: ${({ theme }) => theme.palette.neutral.lightest};
  margin-top: 4rem;
  min-height: 200px;
  line-height: 1.4;
`;

export const ContentWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  padding: 1.5rem 1rem;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
`;

export const Left = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const Socials = styled.div`
  display: flex;
  gap: 1rem;
  font-size: 1.25rem;

  a {
    color: inherit;
    width: 1.5rem;
    height: 1.5rem;
    min-width: 1.5rem;
  }
`;

export const Right = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const LinksColumn = styled.div`
  h3 {
    color: ${({ theme }) => theme.palette.neutral.lightest};
    font-weight: 600;
    margin-bottom: 0.5rem;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    color: ${({ theme }) => theme.palette.neutral.medium};

    li {
      margin-bottom: 0.25rem;

      a {
        color: inherit;
        text-decoration: none;
        transition: color 0.2s;

        &:hover {
          color: ${({ theme }) => theme.palette.primary.light};
        }
      }
    }
  }
`;

export const Bottom = styled.div`
  border-top: 1px solid ${({ theme }) => theme.palette.neutral.medium};
  text-align: center;
  padding: 1rem;
  font-size: 0.75rem;
  color: ${({ theme }) => theme.palette.neutral.medium};
`;